<template>
  <ui-content title="Programación">
    <ui-card title="Filtros">
      <template #toolbar>
        <template v-if="loadingBuscar == false">
          <button
            class="btn btn-sm btn-outline-secondary mr-2"
            @click="onPrintByAgency"
          >
            Imprimir por Agencia
          </button>
          <button
            class="btn btn-sm btn-outline-secondary mr-2"
            @click="onImprimir(false)"
          >
            Imprimir
          </button>
          <button
            class="btn btn-sm btn-outline-secondary mr-2"
            @click="onImprimir(true)"
          >
            Imprimir +Endosados
          </button>
        </template>
        <button
          class="btn btn-sm btn-primary shadow"
          @click="onBuscar"
          :disabled="loadingBuscar"
        >
          Buscar
        </button>
      </template>
      <div class="row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Fecha:</label>
            <InputDatepicker
              v-model="fecha"
              :disabled="loadingBuscar"
            ></InputDatepicker>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Agencia:</label>
            <InputSelect
              :options="agencias"
              v-model="form.agencia"
            ></InputSelect>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Móvil:</label>
            <InputSelect
              :options="vehiculos"
              v-model="form.movil"
            ></InputSelect>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Transfer:</label>
            <InputSelect
              :options="transfers"
              v-model="form.transfer"
            ></InputSelect>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Agrupar Por Servicios:</label>
            <div class="form-control form-control-sm d-inline-block">
              <input type="checkbox" v-model="agrupar" />
            </div>
          </div>
        </div>
      </div>
      <template v-if="loadingBuscar">
        <ui-spinner></ui-spinner>
      </template>
      <template v-else>
        <hr />
        <template v-if="agrupar == false">
          <Table
            :rows="privadosComputed"
            :columns="containers.columns"
            :columnID="'idItinerario'"
            :duplicateScroll="true"
          >
            <template #rows="{ rows }">
              <ProgramacionItem
                v-for="row in rows"
                :key="row.idItinerario"
                :item="row"
                :guias="containers.guias"
                :vehiculos="containers.vehiculos"
                :transfers="containers.transfers"
                :conductores="containers.conductores"
                @update="onUpdateItem"
              ></ProgramacionItem>
            </template>
          </Table>
        </template>
        <template v-else>
          <div
            v-for="grupo in privadosComputed"
            :key="grupo.label"
            class="mb-5"
          >
            <h5>Servicio: {{ grupo.label }}</h5>
            <Table
              :rows="grupo.items"
              :columns="containers.columns"
              :columnID="'idItinerario'"
            >
              <template #rows="{ rows }">
                <ProgramacionItem
                  v-for="row in rows"
                  :key="row.idItinerario"
                  :item="row"
                  :guias="containers.guias"
                  :vehiculos="containers.vehiculos"
                  :transfers="containers.transfers"
                  :conductores="containers.conductores"
                  @update="onUpdateItem"
                ></ProgramacionItem>
              </template>
            </Table>
          </div>
        </template>
        <form @submit.prevent="onSaveComment">
          <div class="form-group mb-2">
            <label for="inputComment" class="form-label">Comentario:</label>
            <textarea
              v-model="comentario"
              class="form-control"
              rows="5"
              id="inputComment"
            ></textarea>
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-sm">Guardar</button>
          </div>
        </form>
      </template>
    </ui-card>
  </ui-content>
</template>
<script>
import Table from "../../modules/shared/components/Table.vue";
import InputDatepicker from "../../modules/shared/components/InputDatepicker.vue";
import ProgramacionItem from "./ProgramacionItem.vue";
import InputSelect from "../../modules/shared/components/InputSelect.vue";
import pdfProgramacion from "../../pdfs/pdfProgramacion";
import pdfProgramacionPorAgencia from "../../pdfs/pdfProgramacionPorAgencia";

export default {
  components: {
    InputSelect,
    ProgramacionItem,
    InputDatepicker,
    Table
  },
  data() {
    return {
      form: {
        agencia: "",
        movil: "",
        transfer: ""
      },
      fecha: this.$dayjs().format("YYYY-MM-DD"),
      agrupar: false,
      comentario: "",
      itinerarios: [],
      loadingBuscar: false,
      tableFields: [
        {
          key: "hora"
        },
        {
          key: "codigo",
          label: "Cód."
        },
        {
          key: "servicio"
        },
        {
          key: "pasajero"
        },
        {
          key: "nroAdultos",
          label: "PAX"
        },
        {
          key: "nroNinos",
          label: "CHD"
        },
        {
          key: "hotel"
        },
        {
          key: "agencia"
        },
        {
          key: "vueloTourTren",
          label: "Vuelo / Tour / Tren"
        },
        {
          key: "identificador",
          label: "Móvil"
        },
        {
          key: "guia",
          label: "Guía"
        },
        {
          key: "transfer"
        },
        {
          key: "abreviatura",
          label: "Idioma"
        },
        {
          key: "servicioTipo",
          label: "Tipo"
        },
        {
          key: "observaciones",
          label: "Obs."
        }
      ],
      containers: {
        fechaBusqueda: "",
        vehiculos: [],
        guias: [],
        transfers: [],
        conductores: [],
        endosados: [],
        containersObtained: false,
        columns: [
          {
            key: "actions",
            label: "",
            width: 30
          },
          {
            key: "hora",
            label: "Hora",
            width: 50
          },
          {
            key: "codigo",
            label: "Código",
            width: 60
          },
          {
            key: "servicio",
            label: "Servicio",
            width: 120
          },
          {
            key: "pasajero",
            label: "Pasajero",
            width: 120
          },
          {
            key: "nroAdultos",
            label: "PAX",
            width: 40
          },
          {
            key: "nroNinos",
            label: "CHD",
            width: 40
          },
          {
            key: "hotel",
            label: "Hotel",
            width: 120
          },
          {
            key: "agencia",
            label: "Agencia",
            width: 120
          },
          {
            key: "vueloTourTren",
            label: "Vuelo/Tour/Tren",
            width: 120
          },
          {
            key: "restaurante",
            label: "Restaurante",
            width: 120
          },
          {
            key: "movil",
            label: "Móvil",
            width: 120
          },
          {
            key: "conductor",
            label: "Conductor",
            width: 120
          },
          {
            key: "guia",
            label: "Guía",
            width: 120
          },
          {
            key: "transfer",
            label: "Transfer",
            width: 120
          },
          {
            key: "idioma",
            label: "IDI.",
            width: 40
          },
          {
            key: "tipo",
            label: "Tipo",
            width: 40
          },
          {
            key: "observacion",
            label: "Observación",
            width: 150
          }
        ]
      }
    };
  },
  computed: {
    agencias() {
      let agencias = this.itinerarios.map(item => item.agencia);
      agencias = [...new Set(agencias)];
      agencias.sort();
      return agencias;
    },
    vehiculos() {
      let vehiculos = this.itinerarios
        .filter(item => !!item.identificador)
        .map(item => item.identificador);
      vehiculos = [...new Set(vehiculos)];
      vehiculos.sort();

      return vehiculos;
    },
    transfers() {
      let transfers = this.itinerarios
        .filter(item => !!item.transfer)
        .map(item => item.transfer);
      transfers = [...new Set(transfers)];
      transfers.sort();
      return transfers;
    },
    privadosOrdenados() {
      const vm = this;
      let elements = [...vm.itinerarios];

      elements.sort(compare);

      function compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const timeA = Number(String(a.hora).replace(/\:+/g, ""));
        const timeB = Number(String(b.hora).replace(/\:+/g, ""));

        let comparison = 0;
        if (timeA > timeB) {
          comparison = 1;
        } else if (timeA < timeB) {
          comparison = -1;
        }
        return comparison;
      }

      return elements;
    },
    privadosComputed() {
      const vm = this;
      let elements = [...vm.filteredItinerarios];

      if (vm.agrupar == false) return elements;

      let grupos = elements.map(item => item.servicio);
      grupos = [...new Set(grupos)];
      grupos.sort();
      grupos = grupos.map(item => ({ label: item, items: [] }));

      elements.forEach(item => {
        let find = grupos.find(grupo => grupo.label == item.servicio);
        find.items.push(item);
      });

      return grupos;
    },
    filteredItinerarios() {
      let { agencia, movil, transfer } = this.form;

      return this.itinerarios.filter(item => {
        let match = false;

        match = !agencia ? true : item.agencia == agencia;
        match = match && (!movil ? true : item.identificador == movil);
        match = match && (!transfer ? true : item.transfer == transfer);

        return match;
      });
    },
    tableFieldsEndosesDia() {
      const vm = this;

      let fields = [
        {
          key: "codigo",
          label: "Cód.",
          tdClass: "text-nowrap"
        },
        {
          key: "fecha",
          tdClass: "text-nowrap"
        },
        {
          key: "horaRecojo"
        },
        {
          key: "horaInicio"
        },
        {
          key: "horaInicioRecojo",
          label: "Hora Inicio / Recojo"
        },
        {
          key: "servicio"
        },
        {
          key: "pasajero"
        },
        {
          key: "nroAdultos",
          label: "PAX"
        },
        {
          key: "nroNinos",
          label: "CHD"
        },
        {
          key: "hotel"
        },
        {
          key: "agencia"
        },
        {
          key: "trenIn"
        },
        {
          key: "trenOut"
        },
        {
          key: "trenInOut",
          label: "Tren In / Out"
        },
        {
          key: "vehiculo"
        },
        {
          key: "conductor"
        },
        {
          key: "vehiculoConductor",
          label: "Vehículo / Conductor"
        },
        {
          key: "guia",
          label: "Guía"
        },
        {
          key: "transfer"
        },
        {
          key: "idioma"
        },
        {
          key: "observaciones"
        },
        {
          key: "file",
          tdClass: "text-nowrap"
        },
        {
          key: "servicioTipo",
          label: "Tipo"
        },
        {
          key: "horaTicket"
        },
        {
          key: "restaurante"
        },
        {
          key: "hotelOvernight"
        },
        {
          key: "horaHuayna",
          label: "Hora Huayna Picchu"
        },
        {
          key: "origen"
        },
        {
          key: "destino"
        }
      ];

      let keys = Object.keys(vm.containers.endosados[0] ?? {});
      keys = [
        ...keys,
        "link",
        "horaInicioRecojo",
        "vehiculoConductor",
        "trenInOut"
      ];

      let fieldsFilter = fields.filter(item => keys.includes(item.key));

      if (
        vm.$findItemByObjectProperty(fieldsFilter, "key", "horaRecojo") ||
        vm.$findItemByObjectProperty(fieldsFilter, "key", "horaInicio")
      ) {
        fieldsFilter = vm.$removeItemByObjectProperty(fieldsFilter, "key", [
          "horaRecojo",
          "horaInicio"
        ]);
      } else {
        fieldsFilter = vm.$removeItemByObjectProperty(
          fieldsFilter,
          "key",
          "horaInicioRecojo"
        );
      }

      if (
        vm.$findItemByObjectProperty(fieldsFilter, "key", "vehiculo") ||
        vm.$findItemByObjectProperty(fieldsFilter, "key", "conductor")
      ) {
        fieldsFilter = vm.$removeItemByObjectProperty(fieldsFilter, "key", [
          "vehiculo",
          "conductor"
        ]);
      } else {
        fieldsFilter = vm.$removeItemByObjectProperty(
          fieldsFilter,
          "key",
          "vehiculoConductor"
        );
      }

      if (
        vm.$findItemByObjectProperty(fieldsFilter, "key", "trenIn") ||
        vm.$findItemByObjectProperty(fieldsFilter, "key", "trenOut")
      ) {
        fieldsFilter = vm.$removeItemByObjectProperty(fieldsFilter, "key", [
          "trenIn",
          "trenOut"
        ]);
      } else {
        fieldsFilter = vm.$removeItemByObjectProperty(
          fieldsFilter,
          "key",
          "trenInOut"
        );
      }

      return fieldsFilter;
    }
  },
  mounted() {
    if (this.fecha) {
      this.onBuscar(true);
    }
  },
  watch: {
    fecha(fecha) {
      console.log({ fecha });
      if (fecha) {
        this.onBuscar();
      }
    }
  },
  methods: {
    async onBuscar(pContainers = false) {
      const vm = this;

      if (vm.loadingBuscar) return;

      if (!vm.fecha) return vm.$toast.fire("Ingresa una fecha", "", "warning");

      let containers = pContainers ? 1 : 0;
      if (vm.containers.containersObtained) containers = 0;

      vm.loadingBuscar = true;

      let response = await vm.axios.get("/itinerarios/privados", {
        params: {
          fecha: vm.fecha,
          containers: pContainers ? 1 : 0
        }
      });

      let itinerarios = response.data.content.busqueda.map(item => ({
        ...item,
        hora: item.hora
          ? vm.$options.filters.date(item.hora, "HH:mm:ss", "HH:mm")
          : ""
      }));

      vm.itinerarios = itinerarios;
      vm.containers.endosados = response.data.content.endosados;
      vm.comentario = response.data.content.comentario || "";

      if (containers) {
        vm.containers.vehiculos = response.data.content.vehiculos;
        vm.containers.guias = response.data.content.guias;
        vm.containers.transfers = response.data.content.transfers;
        vm.containers.conductores = response.data.content.conductores;
        vm.containers.containersObtained = true;
      }

      vm.containers.fechaBusqueda = vm.fecha;

      vm.loadingBuscar = false;
    },
    onUpdate(pId, pTime) {
      let find = this.itinerarios.find(item => item.idItinerario == pId);
      find.hora = pTime;
    },
    onImprimir(pAddEndosados = false) {
      const vm = this;

      const endoses = [...vm.containers.endosados].map(item => ({
        ...item,
        horaInicio: item.horaInicio
          ? vm.$dayjs(item.horaInicio, "HH:mm:ss").format("HH:mm")
          : "",
        horaRecojo: item.horaRecojo
          ? vm.$dayjs(item.horaRecojo, "HH:mm:ss").format("HH:mm")
          : "",
        horaHuayna: item.horaHuayna
          ? vm.$dayjs(item.horaHuayna, "HH:mm:ss").format("HH:mm")
          : "",
        horaTicket: item.horaTicket
          ? vm.$dayjs(item.horaTicket, "HH:mm:ss").format("HH:mm")
          : "",
        fecha: item.fecha ? vm.$dayjs(item.fecha).format("DD-MM-YY") : "",
        conductor: item.conductor || item.otroConductor || '',
        vehiculo: item.vehiculo || item.otroVehiculo || '',
      }));

      const itinerarios = [...vm.filteredItinerarios].map(item => ({
        ...item,
        conductor:
          String(item.conductor || "").trim() ||
          String(item.otroConductor || "").trim(),
        vehiculo: item.identificador || ""
      }));

      const content = {
        itinerarios: itinerarios,
        comentario: vm.comentario,
        endosados: endoses,
        fecha: vm.containers.fechaBusqueda
          ? vm.$dayjs(vm.containers.fechaBusqueda).format("DD-MM-YY")
          : "",
        fieldsEndosados: vm.tableFieldsEndosesDia,
        addEndosados: pAddEndosados,
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format("DD-MM-YY HH:mm")
      };

      pdfProgramacion(content);
    },
    onPrintByAgency() {
      const vm = this;

      const itinerarios = [...vm.filteredItinerarios].map(item => ({
        ...item,
        conductor:
          String(item.conductor || "").trim() ||
          String(item.otroConductor || "").trim()
      }));

      const content = {
        agencia: vm.form.agencia || "Todos",
        itinerarios: itinerarios,
        comentario: vm.comentario,
        fecha: vm.containers.fechaBusqueda
          ? vm.$dayjs(vm.containers.fechaBusqueda).format("DD-MM-YY")
          : "",
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format("DD-MM-YY HH:mm")
      };

      pdfProgramacionPorAgencia(content);
    },
    onSaveComment() {
      const vm = this;

      const fd = {
        comment: String(vm.comentario).trim(),
        dateSearched: vm.containers.fechaBusqueda
      };

      vm.axios
        .put("/itinerarios/privados/update-comment", fd)
        .then(response => {
          vm.$toast.fire("Comentario actualizado", "", "success");
        })
        .catch(error => {
          vm.$toast.fire("Error al actualizar el comentario", "", "error");
        });
    },
    onUpdateItem(pItem) {
      const vm = this;
      let item = vm.itinerarios.find(
        item => item.idItinerario == pItem.idItinerario
      );

      item.identificador =
        vm.containers.vehiculos.find(
          item => item.idVehiculo == pItem.idVehiculo
        )?.identificador || "";
      item.guia =
        vm.containers.guias.find(item => item.idPersona == pItem.idGuia)
          ?.nombre || "";
      item.transfer =
        vm.containers.transfers.find(item => item.idPersona == pItem.idTransfer)
          ?.nombre || "";
      item.conductor =
        vm.containers.conductores.find(
          item => item.idPersona == pItem.idConductor
        )?.nombreCompleto || "";
      item.otroConductor = pItem.otroConductor || "";
      item.observaciones = pItem.observaciones || "";

      this.ordenarItinerario();
    },

    ordenarItinerario() {
      const vm = this;
      const itinerarios = [...vm.itinerarios];

      itinerarios.sort(compare);

      function compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const timeA = Number(String(a.hora).replace(/\:+/g, ""));
        const timeB = Number(String(b.hora).replace(/\:+/g, ""));

        let comparison = 0;
        if (timeA > timeB) {
          comparison = 1;
        } else if (timeA < timeB) {
          comparison = -1;
        }
        return comparison;
      }

      vm.itinerarios = itinerarios;
    }
  }
};
</script>
